require('../../app.js')

Vue.component('agency-show-v1', require('./Show-v1.vue').default)
Vue.component('agency-show-v2', require('./Show-v2.vue').default)
